export default __webpack_public_path__ + "static/media/eAppPlaceholder.09b075fa.svg";